<script setup lang="ts">
import 'video.js/dist/video-js.css'
import Header from './@components/Header/index.vue'
import IntroducerSection from './@components/IntroducerSection/index.vue'
import DemonstrationSection from './@components/DemonstrationSection/index.vue'
import CompatibilitySection from './@components/CompatibilitySection/index.vue'
import DetailsSection from './@components/DetailsSection/index.vue'
import VideoPlayer from './@components/VideoPlayer/index.vue'
import GetStartedSection from './@components/GetStartedSection/index.vue'
import Footer from './@components/Footer/index.vue'
import { getHostname } from '~~/src/api'
import { SEO } from '@/utils/constants'
import { getBreadcrumbsJsonLd } from '~~/src/helpers/serp'

const host = getHostname()

const title = `Magic Keys | ${SEO.title}`
const description = 'The spellbinding plugin that enhances your AI skills. Magic simplifies prompt management, integrates hotkeys to ChatGPT and offers thousands of prompts made by Snack Prompt community.'
const image = `${host}/magickeys-banner.jpg`

const jsonldBreadcrumbs = getBreadcrumbsJsonLd([
  { name: title, url: LINKS.magicPage },
])

useHead({
  meta: [
    { name: 'og:title', content: title },
    { name: 'og:description', content: description },
    { name: 'og:url', content: LINKS.magicPage },
    { name: 'og:image', content: image },
    { name: 'twitter:image', content: image },
  ],
  script: [
    {
      hid: 'page-json-ld',
      type: 'application/ld+json',
      innerHTML: JSON.stringify(jsonldBreadcrumbs),
    },
  ],
})

useServerSeoMeta({
  title,
  keywords: 'Magic Keys, SnackPrompt, IA, ChatGPT, Extensions',
  description,
  ogTitle: title,
  ogDescription: 'The spellbinding plugin that enhances your AI skills. Magic simplifies prompt management, integrates hotkeys to ChatGPT and offers thousands of prompts made by Snack Prompt community.',
  ogImage: image,
  twitterTitle: title,
  twitterImage: image,
  twitterDescription: 'The spellbinding plugin that enhances your AI skills. Magic simplifies prompt management, integrates hotkeys to ChatGPT and offers thousands of prompts made by Snack Prompt community.',
})
</script>

<template>
  <NuxtLayout name="default">
    <div flex pt-40px>
      <main w-full>
        <Header />
        <VideoPlayer />
        <IntroducerSection />
        <CompatibilitySection />
        <DemonstrationSection />
        <DetailsSection />
        <StaticSocialCaroussel />
        <GetStartedSection />
        <Footer />
      </main>
    </div>
  </NuxtLayout>
</template>

<style lang="scss" module>
.gradient-text {
  font-size: 20px;
  font-weight: bold;
  background: linear-gradient(#FF88EC, #A993FF, #2376E5);
  background-clip: text;
  color: transparent;
}
</style>
